import { EffectCallback, useEffect } from 'react'

// Runs an effect once, on mount (and its cleanup on unmount). Use for genuinely mount-only
// effects (initial fetch, one-time URL parsing, mount-time analytics) where reacting to later
// dependency changes is explicitly NOT wanted. This is the intent that a bare `useEffect(fn, [])`
// plus an `eslint-disable react-hooks/exhaustive-deps` used to express, centralised in one place.
export function useMountEffect(effect: EffectCallback): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, [])
}

export default useMountEffect
